export default __webpack_public_path__ + "img/port.fbcc926e.png";